<div class="content-wrapper-inner relative">
  <div class="page-content">
    <div class="table-topbar mb-20">
      <div class="search-holder">
        <input type="search" placeholder="Search" class="form-control table-search" [formControl]="searchControl" />
        <span class="icon-search"></span>
      </div>
      <div class="table-action-holder">
        <div class="create">
          <a (click)="onCreate()" class="btn btn-primary py-10 px-15"><span class="icon-add"></span>Add country</a>
        </div>
      </div>
    </div>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-country-table (changeBatch)="selectedRows = $event"></app-country-table>
      <!-- The table on batch select has an action menu shown … -->
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{selectedRows.length}} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onBatchDelete()">
            <span class="icon">
              <span class="far fa-trash-alt"></span>
            </span>
            <span class="text">Delete</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
